"use client";

import React from "react";
import {
    FacebookShareButton,
    PinterestShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    FacebookIcon,
    PinterestIcon,
    WhatsappIcon,
    XIcon,
} from 'react-share';
import { useShareModalStore } from "@/app/store/localapi";
import styles from './ShareModal.module.css';

const LinkIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72"></path>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72"></path>
    </svg>
);

const CheckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);

/* eslint-disable @next/next/no-img-element */
export function ShareModal({ onShare }: { onShare?: () => void } = {}) {
    const { isOpen, drama, closeShareModal } = useShareModalStore();
    const [shareUrl, setShareUrl] = React.useState('');
    const [copied, setCopied] = React.useState(false);
    const [title, setTitle] = React.useState('');

    React.useEffect(() => {
        if (drama) {
            // Use base URL for DramaFlicks share
            setShareUrl(`https://dramaflicksapp.com`);
            setTitle(`Join me on DramaFlicks! Watch amazing short dramas. Download now:`);
        }
    }, [drama]);

    const handleShare = () => {
        if (onShare) onShare();
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            setCopied(true);
            handleShare();
            setTimeout(() => setCopied(false), 3000); // Reset after 3 seconds
        });
    };

    // Don't render anything if the modal is closed or there's no drama data
    if (!isOpen || !drama) {
        return null;
    }

    return (

        <div className={styles.modalOverlay} onClick={closeShareModal}>
            <div className={styles.mainBox}>
                <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>


                    <div className={styles.dramaSummarySec}>
                        <div className={styles.header}>
                            <h2>Share</h2>
                            <button onClick={closeShareModal} className={styles.closeButton}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none"><path d="M12.8015 0.744073C12.4427 0.385334 11.8632 0.385334 11.5045 0.744073L7.00645 5.23291L2.50842 0.734874C2.14968 0.376136 1.57018 0.376136 1.21144 0.734874C0.852698 1.09361 0.852698 1.67311 1.21144 2.03185L5.70947 6.52988L1.21144 11.0279C0.852698 11.3867 0.852698 11.9662 1.21144 12.3249C1.57018 12.6836 2.14968 12.6836 2.50842 12.3249L7.00645 7.82686L11.5045 12.3249C11.8632 12.6836 12.4427 12.6836 12.8015 12.3249C13.1602 11.9662 13.1602 11.3867 12.8015 11.0279L8.30342 6.52988L12.8015 2.03185C13.151 1.68231 13.151 1.09361 12.8015 0.744073Z" fill="#A2A2A2"></path></svg>

                            </button>
                        </div>
                        <div className={styles.dramaSummary}>
                            <div className={styles.dramaIg}>
                                <img src={drama?.image_url || drama?.d_image} alt={drama.drama_name} loading='lazy' />
                            </div>
                            <div className={styles.dramaAbout}>
                                <h3>{drama?.drama_name || drama?.d_name}</h3>
                                <p className={styles.dramaDesc}>{drama.d_desc || 'No description available.'}</p>
                            </div>
                        </div>
                    </div>
                    {/* <p style={{textAlign:'center',color:'#666'}}>{shareUrl}</p> */}
                    <div className={styles.socialIcons} onClick={(e) => e.stopPropagation()}>
                        <ul>
                            <li onClick={handleShare}>
                                <FacebookShareButton url={shareUrl} title={title}>
                                    <FacebookIcon size={45} round />
                                </FacebookShareButton>
                            </li>
                            <li onClick={handleShare}>
                                <TwitterShareButton url={shareUrl} title={title}>
                                    <XIcon size={45} round />
                                </TwitterShareButton>
                            </li>
                            <li onClick={handleShare}>
                                <PinterestShareButton url={shareUrl} media={drama.image_url} description={title}>
                                    <PinterestIcon size={45} round />
                                </PinterestShareButton>
                            </li>
                            <li onClick={handleShare}>
                                <WhatsappShareButton url={shareUrl} title={title} separator="-">
                                    <WhatsappIcon size={45} round />
                                </WhatsappShareButton>
                            </li>

                            <li>
                                <button onClick={handleCopy} className={`${styles.copyButton} ${copied ? styles.copied : ''}`} title="Copy Share URL">
                                    {copied ? <CheckIcon /> : <LinkIcon />}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
}